/** D70 FE6 — staging-only sandbox indicator copy (never rendered on production). */
export const sandboxDataCopy = {
  indicator: 'Synthetic sandbox data',
};
